import { LOANS } from '../../../common/domain/constants.loans.js';

class LoansSignUpFormSimulationController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.HOUSING_MANDATORY_PURPOSE = LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
    this.showErrorSelect = false;
    this.codeOptionSelected = null;

  }

  $onInit() {
    this._setInitialData();
    this._forceLoanPurpose();
    this.codeOptionSelected = this.loan.idHr;

  }

  _setInitialData() {
    if (this.simulation) {
      this.loanPurpose = this.simulation.loanPurpose;

    }
  }

  _forceLoanPurpose() {
    const isSocialOrAgreementLoan = this.loan.id === LOANS.ID.SOCIAL_HOUSING_LOAN
      || this.loan.id === LOANS.ID.AGREEMENT_HOUSING_LOAN;

    if (isSocialOrAgreementLoan) {
      this.loanPurpose = this._findLoanPurposeByCode(this.HOUSING_MANDATORY_PURPOSE);
      this.disableLoanPurposeSelector = true;
    }
  }

  _findLoanPurposeByCode(code) {
    return this.loanPurposes.find((purpose) => purpose.value === code);
  }

  selectLoanPurposesDisabled() {
    const invalidLoanPurposes = !this.loanPurposes || this.loanPurposes.length === 0;
    const forcedSelection = this.disableLoanPurposeSelector;
    return invalidLoanPurposes || forcedSelection;
  }

  onSelectLoanPurpose($event) {
    this.loanPurpose = $event.$item;
    this.showErrorSelect = false;
  }

  onErrorInSelect() {
    this.showErrorSelect = true;
  }

  setAmountSimulation($event) {
    this.amountSimulation = $event;
    this.onSubmit(this.EventEmitter(this._getFormData()));
  }

  _getFormData() {
    return {
      loanPurpose: this.loanPurpose,
      amountSimulation: this.amountSimulation,
    };
  }

  showHousingChangeWarning() {
    return this.housingLoan && this.housingChange;
  }

  hideAmountSimulation() {
    return this.isMobileApp && !this.loanPurpose;
  }
  isHousingMandatoryPurpose() {
    return (this.loan.idHr == LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr == LOANS.ID_HR.AGREEMENT_HOUSING_LOAN);
  }
  shouldShowMessageWarning() {
    return this.housingChange && !this.simulationWitness && this.loan.idHr == LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
  }
  shouldShowCreditCapacitySimulation() {
    return this.simulationWitness && (this.loan.idHr == LOANS.ID_HR.SOCIAL_HOUSING_LOAN || this.loan.idHr == LOANS.ID_HR.AGREEMENT_HOUSING_LOAN || this.loan.idHr == LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE);
  }
}

export default LoansSignUpFormSimulationController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulation.controller.js